import ReactGA from "react-ga";

const trackingCode = "G-03F25YBFHR";

export const initializeGoolgeAnalytics = () => {
  ReactGA.initialize(trackingCode, {
    debug: true,
    titleCase: false,
    testMode: process.env.NODE_ENV === "test",
  });
  ReactGA.ga("set", "checkProtocolTask", () => {});
  ReactGA.event({
    category: "Test",
    action: "Test action",
  });
  recordPageLoad();
};

export const sendPageViewsAnalytics = (location) => {
  //ReactGA.set({ page: location?.pathname });
  ReactGA.pageview(location?.pathname);
};

const recordPageLoad = () => {
  if (window.performance) {
    const timeSincePageLoad = Math.round(performance.now());

    ReactGA.timing({
      category: "Page Load Time",
      variable: "load",
      value: timeSincePageLoad, // in milliseconds
      label: window.location.pathname,
    });
  }
};
